export enum urlApi {
    URL_VIEW_DIGITAL_CERTIFICATE = 'crm/cau-hinh-chung-thu-so/getFile',
    URL_VIEW_SIGN_SAMPLE = 'crm/cau-hinh-mau-chu-ky/getFile',
    URL_VIEW_SUBMISSION = 'crm/tai-lieu-trinh-ky/getFile',
    URL_VIEW_STEP_SUBMISSION = 'crm/tai-lieu-trinh-ky/getFileStep',
    URL_VIEW_CONTRACT = 'crm/quan-ly-hop-dong/getFile',
    URL_VIEW_STEP_CONTRACT = 'crm/quan-ly-hop-dong/getFileStep',
    URL_VIEW_CONTRACT_DOCUMENT = 'crm/quan-ly-ho-so-hop-dong/getFile',
    URL_VIEW_STEP_CONTRACT_DOCUMENT = 'crm/quan-ly-ho-so-hop-dong/getFileStep',
    URL_GET_USER_INFO = 'crm/tai-khoan/getUserInfo',
    URL_FOLDER_DOCUMENT = 'crm/thu-muc-tai-lieu/download',
    URL_PERSONAL_DOCUMENT = 'crm/tai-lieu-ca-nhan/getFile',
    URL_FILE_AUTH_MANAGER = 'crm/quan-ly-uy-quyen/getFile',
    URL_FILE_DOC_TEMP = 'crm/danh-muc-mau-tai-lieu/getFile',
    PATH_URL_PERSONAL_DOCUMENT = 'tai-lieu-ca-nhan',
    URL_GET_CERT_PLUGIN = 'cybercrm/getcert',
    URL_SIGN_PDF_SERIAL_PLUGIN = 'cybersign/signPdfSerial',
    URL_SIGN_PDF_PLUGIN = 'cybersign/signpdf',
    URL_DOWNLOAD_ALL_FILE_SUBMISSION = 'crm/tai-lieu-trinh-ky/downloadAllFile',
    URL_DOWNLOAD_ALL_FILE_SUBMISSION_REFUSE = 'crm/trinh-ky-da-tu-choi/downloadAllFile',
    URL_DOWNLOAD_ALL_FILE_CONTRACT = 'crm/quan-ly-hop-dong/downloadAllFile',
    URL_CUSTOMER_DOWNLOAD_ALL_FILE_CONTRACT = 'client/hop-dong-khach-hang/downloadAllFile',
    URL_CUSTOMER_DOWNLOAD_ALL_FILE_SUBMISSION = 'client/trinh-ky-khach-hang/downloadAllFile',
    URL_VIEW_CONTRACT_CLIENT = 'client/hop-dong-khach-hang/getFile',
    URL_VIEW_SUBMISSION_CLIENT = 'client/trinh-ky-khach-hang/getFile',
    URL_DOWNLOAD = 'client/quan-ly-phan-mem/download',
    URL_DOC_SENT = 'crm/tai-lieu-di/getFileContent',
    URL_DOC_COME = 'crm/tai-lieu-den/getFileContent',
    URL_VIEW_REFERENCE_TEMPLATE = 'crm/mau-tham-khao/getFile',
}

